import { render, staticRenderFns } from "./app-category-staff.vue?vue&type=template&id=4f5f6976&"
import script from "./app-category-staff.vue?vue&type=script&lang=js&"
export * from "./app-category-staff.vue?vue&type=script&lang=js&"
import style0 from "./app-category-staff.vue?vue&type=style&index=0&id=4f5f6976&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports